import { render, staticRenderFns } from "./RecursosFilter.vue?vue&type=template&id=95f84506"
import script from "./RecursosFilter.vue?vue&type=script&lang=js"
export * from "./RecursosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports